'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { LoginCard } from '../loginCard';
import { NewPasswordFields } from '../newPasswordFields';
export const NewPasswordStep = t0 => {
  const $ = _c(20);
  const {
    error,
    submitting,
    onSubmit
  } = t0;
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const passwordsMatch = newPassword === confirmPassword;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography variant="subtitle1" className="text-center">Set a new password to continue:</Typography>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== newPassword || $[2] !== onSubmit || $[3] !== passwordsMatch) {
    t2 = event => {
      event.preventDefault();
      if (newPassword && passwordsMatch) {
        onSubmit(newPassword);
      }
    };
    $[1] = newPassword;
    $[2] = onSubmit;
    $[3] = passwordsMatch;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "100%",
      gap: "40px"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== confirmPassword || $[7] !== newPassword) {
    t4 = <NewPasswordFields idPrefix="login-v2" newPasswordAutoFocus={true} newPassword={newPassword} confirmPassword={confirmPassword} onNewPasswordChange={setNewPassword} onConfirmPasswordChange={setConfirmPassword} />;
    $[6] = confirmPassword;
    $[7] = newPassword;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = !newPassword || !passwordsMatch || submitting;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      height: "48px"
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = submitting ? "Saving\u2026" : "Continue";
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <Button fullWidth={true} type="submit" variant="contained" disabled={t5} data-testid="login-v2-new-password-submit" sx={t6}>{t7}</Button>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t2 || $[14] !== t4 || $[15] !== t8) {
    t9 = <Stack component="form" onSubmit={t2} sx={t3}>{t4}{t8}</Stack>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== error || $[18] !== t9) {
    t10 = <LoginCard error={error}>{t1}{t9}</LoginCard>;
    $[17] = error;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};